import React from 'react';

import styles from '../styles/Global';
import assets from '../assets';
import AppStoreButtons from './AppStoreButtons';
import { useLanguage } from '../contexts/LanguageContext';

const Download: React.FC = () => {
  const { t } = useLanguage();

  return (
    <div id="download" className={`${styles.section} ${styles.bgWhite}`}>
      <div className={`${styles.subSection} flex-col text-center`}>
        <div>
          <h1 className={`${styles.h1Text} ${styles.blackText}`}>{t.download.title}</h1>
          <p className={`${styles.pText} ${styles.blackText}`}>{t.download.description}</p>
        </div>
        <AppStoreButtons className="mt-8" />
        <div className={styles.flexCenter} style={{ marginTop: '3rem' }}>
          <img 
            src={assets.scene}
            alt="multiple_levels"
            className={styles.fullImg}
          />
        </div>
      </div>
    </div>
  );
};

export default Download;
